<template>
  <div class="declareContainer">
    <div class="headerCon">
      <div class="left">
        <van-icon name="arrow-left" @click="$router.replace('/insuranceHome');" />
      </div>
      <div class="headerTit">关联子女申报</div>
      <div class="right">
        <van-popover v-model="showHint" trigger="click" placement="bottom-end">
          <div class="hintCon" style="padding: 10px 20px; width: 200px; font-size: 14px">
            参保子女年龄限制为0至22周岁(含)，其中:新生儿需已健康出院;超过16周岁的子女必须为在校学生且仅限于未婚子女。
          </div>
          <template #reference>
            <img src="@/assets/insurance/hint.png" alt="" />
          </template>
        </van-popover>
      </div>
    </div>
    <div class="contenCon">
      <van-form ref="form" :scroll-to-error="true">
        <van-cell-group>
          <van-field v-model="name" label="员工姓名" :readonly="$route.query.isEdit != 'true'" :rules="[{ required: true }]"
            v-if="$route.query.isEdit != 'true'" />

          <van-field label="员工姓名" name="name" :rules="[{ required: nameIsRequired, message: '请选择员工姓名' }]" v-else>
            <template #input>
              <el-select v-model="name" placeholder="请选择员工姓名" clearable filterable remote :remote-method="changeOption"
                :loading="loadingSelect" ref="select" @blur.native.capture="onblur" @hook:mounted="cancalReadOnly"
                @visible-change="cancalReadOnly" @change="changeName">
                <el-option v-for="item in options" :key="item.empid" :label="item.workcode + '/' + item.name"
                  :value="item.workcode + '/' + item.name">
                </el-option>
              </el-select>
            </template>
          </van-field>

        </van-cell-group>
        <van-cell-group>
          <van-field label="是否为子女参保" name="isInsured" :rules="[{ required: true, message: '请选择是否为子女参保' }]"
            placeholder="请选择是否为子女参保">
            <template #input>
              <van-radio-group v-model="isInsured" direction="horizontal">
                <van-radio :name="1">是</van-radio>
                <van-radio :name="0">否</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <div v-if="isInsured == 1" style="font-size: 10px;color: red;padding: 0 10px;">
            注意：参保子女年龄限制为0至22周岁(含)，其中:新生儿需已健康出院;超过16周岁的子女必须为在校学生且仅限于未婚子女。</div>
        </van-cell-group>
        <van-cell-group v-if="isInsured == 1">
          <van-field v-model="childName" name="childName" label="投保子女姓名" placeholder="请输入…"
            @click-input="isShowChildrenNamet" :rules="[{ required: true }]"/>
          <van-popup v-model="showChildrenNamet" position="bottom" overlay-class="popupCon">
            <van-picker show-toolbar :columns="childrenNameList" @confirm="confirmChildrenNamet"
              @cancel="cancelChildrenNamet" />
          </van-popup>
        </van-cell-group>
        <van-cell-group v-if="isInsured == 1">
          <van-field name="gender" label="投保子女性别" :rules="[{ required: true, message: '请选择投保子女性别' }]">
            <template #input>
              <van-radio-group v-model="gender" direction="horizontal">
                <van-radio :name="1">男</van-radio>
                <van-radio :name="2">女</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </van-cell-group>
        <van-cell-group v-if="isInsured == 1">
          <van-field v-model="idType" name="showCardType" label="投保子女证件类型" placeholder="请输入"
            @click-input="isShowCardType" readonly :rules="[{ required: true }]">
            <template #button>
              <van-icon name="arrow-down" />
            </template>
          </van-field>
          <van-popup v-model="showCardType" position="bottom">
            <van-picker show-toolbar :columns="cardTypeList" @confirm="confirmShowCardType" @cancel="cancelShowCardType"
              :default-index="2" />
          </van-popup>
        </van-cell-group>
        <van-cell-group v-if="isInsured == 1">
          <van-field v-model="idNumber" name="idNumber" label="投保子女证件号" placeholder="请输入…"
            :rules="[{ required: true }, idCard()]" @blur="changeIdNumber" />
        </van-cell-group>
        <van-cell-group v-if="isInsured == 1">
          <van-field @click-input="showBirthdate" name="isShowBirthdate" readonly
            :rules="[{ required: true }, birthTime()]" v-model="birthDate" label="投保子女出生日期" placeholder="请选择投保子女出生日期">
            <template #button>
              <img class="fieldImg" src="@/assets/insurance/date.png" alt="" />
            </template>
          </van-field>
          <van-popup v-model="isShowBirthdate" position="bottom">
            <van-datetime-picker v-model="BirthdateTime" type="date" title="年月日" @confirm="comfirmBirthdate"
              @cancel="isShowBirthdate = false" :min-date="minDate" :max-date="maxDate" />
          </van-popup>
        </van-cell-group>
        <van-cell-group v-if="isInsured == 1">
          <van-field label="投保子女婚否" name="isMarried"
            :rules="[{ required: isGrowUp, message: '请选择投保子女婚否' }, isMarriedValidator()]">
            <template #input>
              <van-radio-group v-model="isMarried" direction="horizontal">
                <van-radio :name="1">是</van-radio>
                <van-radio :name="0">否</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </van-cell-group>
        <van-cell-group v-if="isInsured == 1">
          <van-field label="投保子女是否在校生" name="isStudent" :rules="[
            { required: isGrowUp, message: '请选择投保子女是否在校生' }, isStudentValidator()
          ]">
            <template #input>
              <van-radio-group v-model="isStudent" direction="horizontal">
                <van-radio :name="1">是</van-radio>
                <van-radio :name="0">否</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </van-cell-group>
        <van-cell-group v-if="isInsured == 1 && isStudent == 1">
          <van-field v-model="schoolCity" name="schoolCity" label="投保子女学校城市" placeholder="请输入"
            @click-input="showSchoolCity" readonly :rules="[{ required: true }]">
            <template #button>
              <van-icon name="arrow-down" />
            </template>
          </van-field>
          <van-popup v-model="isSchoolCity" position="bottom">
            <van-area title="请选择" :value="cityCode" :area-list="areaList" @confirm="confirmSchoolCity"
              @cancel="isSchoolCity = false" />
          </van-popup>
        </van-cell-group>
        <van-cell-group v-if="isInsured == 1 && isStudent == 1">
          <van-field v-model="schoolName" name="schoolName" label="投保子女学校名称" placeholder="请输入…"
            :rules="[{ required: true }]" />
        </van-cell-group>
      </van-form>
    </div>
    <div class="footerBtn">
      <van-button type="info" size="small" style="width: 45%; background-color: #f3f3f3; color: #282b32"
        @click="cancelBack">取消</van-button>
      <van-button type="info" size="small" style="width: 45%; background-color: #4ea27c" @click="handleConfirm"
        :disabled="confirmLoading" v-loading="confirmLoading">确认</van-button>
    </div>
    <!-- 点击确认显示  -->
    <!-- confirmButtonText="变更" confirmButtonColor="#0F8CFF" cancelButtonText="新增" cancelButtonColor="#0F8CFF"
      @confirm="confirmChange" @cancel="addChange" -->
    <van-dialog v-model="showChange" title="提示" :showCancelButton="false" :showConfirmButton="false">
      <div class="changeCon">
        <div class="changeIcon">
          <van-icon name="cross" @click="showChange = false" />
        </div>
        <!-- {{ this.childName }} -->
        <div style="padding: 30px 20px 20px 20px">
          公司付费提供一个关联子女名额，您已填报相关子女，是否继续变更
        </div>
        <div class="dialogBtn">
          <van-button style="width: 50%;height: 45px;color: #0F8CFF;border-radius: 0;font-size: 16px;"
            @click="addChange" :disabled="confirmLoading" v-loading="confirmLoading">新增</van-button>
          <van-button style="width: 50%;height: 45px;color: #0F8CFF;border-radius: 0;font-size: 16px;"
            @click="confirmChange" :disabled="changeLoading" v-loading="changeLoading">变更</van-button>
        </div>
      </div>
    </van-dialog>
    <!-- 选择变更子女 -->
    <van-popup v-model="isShowChangeChildren" position="bottom">
      <van-picker show-toolbar :columns="childrenNameList" @confirm="confirmShowChangeChildren"
        @cancel="isShowChangeChildren = false" />
    </van-popup>
  </div>
</template>

<script>
import apis from "@/apis/insurance";
import moment from "moment";
import apiLogin from "@/apis";
// import "moment/locale/zh-cn";
import "@/assets/car/icon/iconfont.css";
import { areaList } from "@vant/area-data";
import { getToken } from "@/utils/cookie";
export default {
  name: "declare",
  data() {
    return {
      showHint: false,
      name: "", //姓名
      empno: "", //工号
      isInsured: 1, //是否为子女参保
      childName: "", //投保子女姓名
      gender: "", //性别
      idType: "身份证", //证件类型
      // childInfoList:[],//子女信息
      showChildrenNamet: false, //是否显示子女姓名选择框
      childrenNameList: ["暂无子女"], // 子女姓名列表
      showCardType: false,
      cardTypeList: [
        "户口本（未办身份证适用）",
        "出生证明（新生儿适用）",
        "身份证",
        "临时身份证",
        "护照",
        "军官证士兵证",
        "外国人永久居留证",
        "港澳居民居住证",
        "台湾居民居住证",
        "其他"
      ],
      idNumber: "", //证件号
      birthDate: "", //出生日期
      isShowBirthdate: false,
      BirthdateTime: new Date(),
      isMarried: "", //是否结婚
      isStudent: "", //投保子女是否在校生
      schoolCity: "", // 学校城市
      cityCode: "", // 城市编码
      isSchoolCity: false, //是否显示学校城市
      schoolName: "", // 学校
      minDate: new Date(1900, 10, 1),
      maxDate: new Date(),
      areaList: areaList,
      // cityCode: '',
      isGrowUp: true, // 是否成年
      showChange: false,
      isShowChangeChildren: false, // 是否显示变更子女
      editId: "",
      childList: [],// 所有的子女信息
      options: [],
      loadingSelect: false,
      nameIsRequired: true,
      childInfoIdNumber: {},
      isToDeclare: false,
      confirmLoading: false,
      changeLoading: false
    };
  },
  mounted() {
    // let token = window.sessionStorage.hrToken;
    let token = getToken();
    if (token) {
      this.queryUser(token);
    } else {
      this.$bus.$on("processToken", (res) => {
        Promise.resolve(this.getHrToken(res)).then(() => {
          this.queryUser(res);
        });
      });
    }

  },
  methods: {
    //获取hrToken&用户信息
    getHrToken(username) {
      return new Promise((resolve) => {
        // console.log("username:" + new Date(), username);
        if (username) {
          let thisname = username;
          if (thisname === "17625010228" || thisname === "17637403245") {
            thisname = "10005038";
          } else if (thisname === "15093054787") {
            thisname = "10005038";
          }

          apiLogin.getUserToken({ username: thisname }).then((data) => {
            const info = data.data;
            localStorage.setItem("salaryInfo", JSON.stringify(info));
            window.sessionStorage.hrToken = info.auth_token;
            window.sessionStorage.empNo = info.empNo;

            if (this.$route.query.isEdit == 'true') {
              this.name = '';
            } else {
              this.name =
                data.data.empNo +
                "/" +
                data.data.title;
            }
            this.empno = getToken();
            if (this.name.split("/")[0]) {
              this.queryByChildName();
            }
            resolve();
          });
        } else {
          // console.log("未登录");
          resolve();
        }
      });
    },
    //根据token获取用户信息
    queryUser(token) {
      apis.queryByUsernames({ username: token }).then(res => {
        if (res.code == 200) {
          console.log(1111111111, res.data);
          // this.getHrToken(window.sessionStorage.empNo);
          if (res.data && res.data.userid) {
            if (this.$route.query.isEdit == 'true') {
              this.name = '';
            } else {
              this.name =
                res.data.userid +
                "/" +
                res.data.nickname;
            }
            this.empno = token;
            if (this.name.split("/")[0]) {
              this.queryByChildName();
            }
          } else {
            this.getHrToken(token);
          }

          this.isToDeclare = res.data.isDeclare == 1 ? false : true;
          if (!this.isToDeclare && this.$route.query.isEdit != 'true') {
            this.$router.replace('/commercialQuery');
          }
        }
      });
    },
    //身份证号校验
    idCard() {
      const idCardRegex =
        /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      return {
        validator: () => {
          return this.idType == '身份证' ? idCardRegex.test(this.idNumber) ? true : false : true;
        },
        message: "请输入正确的身份证号",
        trigger: "onChange"
      };
    },
    //是否超过22岁校验
    birthTime() {
      if (this.birthDate) {
        let selected = true;
        const currentDate = new Date(); // 获取当前日期
        const selectedYear = new Date(this.birthDate).getFullYear(); // 选择日期的年份
        const selectedMonth = new Date(this.birthDate).getMonth() + 1; // 选择日期的月份
        const selectedDay = new Date(this.birthDate).getDate(); // 选择日期的日期
        const currentYear = currentDate.getFullYear(); // 当前日期的年份
        const currentMonth = currentDate.getMonth() + 1; // 当前日期的月份
        const currentDay = currentDate.getDate(); // 当前日期的日期
        // 计算年龄差距
        const ageDifference = currentYear - selectedYear;
        // 如果年龄差距大于22岁，则选择日期距离当前日期超过22岁
        if (ageDifference > 23) {
          selected = false;
        }
        // 如果年龄差距等于22岁，则比较月份和日期，确保不超过22岁
        else if (ageDifference === 23) {
          // 如果选择日期的月份大于当前日期的月份，则未满22岁
          if (selectedMonth > currentMonth) {
            selected = true;
          }
          // 如果选择日期的月份等于当前日期的月份，比较日期
          else if (selectedMonth === currentMonth) {
            // 如果选择日期的日期大于当前日期的日期，则未满22岁
            if (selectedDay > currentDay) {
              selected = true;
              // 如果选择日期的日期等于当前日期的日期，则包含22岁
            } else if (selectedDay == currentDay) {
              selected = true;
            } else {
              selected = false;
            }
          } else {
            selected = false;
          }
        }
        return {
          validator: () => {
            return selected;
          },
          message: "投保子女出生日期应在0~22岁之间",
          trigger: "onChange"
        };
      } else {
        return {
          validator: () => {
            return true;
          },
          message: "投保子女出生日期应在0~22岁之间",
          trigger: "onChange"
        };
      }
    },
    //投保子女婚否验证
    isMarriedValidator() {
      return {
        validator: () => {
          return this.isMarried === 1 ? false : true;
        },
        message: "您不符合申报条件",
        trigger: "onChange"
      };

    },
    //投保子女是否在校生验证
    isStudentValidator() {
      const sss = this.isGrowUp && this.isStudent === 0;
      return {
        validator: () => {
          return sss ? false : true;
        },
        message: "超过16周岁不是在校生,您不符合申报条件",
        trigger: "onChange"
      };
    },
    // 证件号
    changeIdNumber() {
      if (this.idNumber && this.idType == '身份证') {
        this.$refs.form.resetValidation('isMarried');
        this.$refs.form.resetValidation('isStudent');
        let birthday = "";
        let time = '';
        birthday = this.idNumber.substr(6, 8);
        time = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
        console.log('time111', time);
        this.birthDate = time;
        this.BirthdateTime = new Date(time);
        this.isExceedSixteen();
        // let currentDate = new Date();
        // let currentYear = currentDate.getFullYear();
        // let selectedYear = new Date(time).getFullYear();
        // if (currentYear >= selectedYear + 17) {
        //   console.log("当前日期大于等于16年");
        //   this.isGrowUp = true;
        // } else {
        //   this.isGrowUp = false;
        //   console.log("当前日期小于16年");
        // }
      }
    },
    //判断是否满16岁
    isExceedSixteen() {
      const selectedDate = moment(this.birthDate, "YYYY-MM-DD");
      // 获取当前日期
      const currentDate = moment();

      // 计算年龄差距
      const ageDifference = currentDate.diff(selectedDate, 'years');

      // 判断是否超过20岁
      if (ageDifference >= 16) {
        this.isGrowUp = true;
        console.log('满16岁');
      } else {
        this.isGrowUp = false;
        console.log('不满16岁');
      }
    },
    //获取员工姓名
    changeOption(value) {
      this.loadingSelect = true;
      apis
        .quaGetEmployeeInfo({
          name: value,
        })
        .then((data) => {
          this.options = data.data;
          this.loadingSelect = false;
        });
    },
    // 在苹果手机上唤起键盘
    onblur() {
      setTimeout(() => {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          //判断iPhone|iPad|iPod|iOS
          this.$refs.select.blur();
        }
        var scrollHeight =
          document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      }, 100);

    },
    // 在苹果手机上唤起键盘 取消只读
    cancalReadOnly(onOff) {
      this.$nextTick(() => {
        if (!onOff) {
          const { select } = this.$refs;
          const input = select.$el.querySelector(".el-input__inner");
          input.removeAttribute("readonly");
        }
      });
    },
    // 改变员工姓名
    changeName() {
      if (this.name) {
        this.nameIsRequired = false;
        this.$refs.form.resetValidation('name');
        this.queryByChildName();
        console.log('this.name, console.log(this.name);', this.name);
      } else {
        this.nameIsRequired = true;
        this.childrenNameList = [];
      }

    },
    // 获取子女投保信息
    queryByChildName() {
      this.editId = '';
      this.gender = '';
      this.idType = '身份证';
      this.childName = '';
      this.idNumber = '';
      this.birthDate = '';
      this.BirthdateTime = new Date();
      this.isMarried = '';
      this.isStudent = '';
      this.schoolCity = '';
      this.schoolName = '';
      this.cityCode = '';
      const userId = this.name.split("/")[0];
      const json = {
        empno: userId,
        page: 1,
        pageSize: 1000,
        filterPolicyStatus: '失效'
      };
      apis.queryEmployeeChild(json).then(res => {

        if (res.code == "200") {
          this.childList = res.data;
          this.childrenNameList = res.data.map(item => {
            return {
              text: item.childName,
              value: item.idNumber
            };
          });
          console.log('this.childrenNameList', this.childrenNameList, res.data);
        }
      });
    },
    // 新增编辑子女投保信息
    addOrUpdateEmployeeChilds(id) {
      this.confirmLoading = true;
      const userId = this.name.split("/")[0];
      const json = {
        employeeName: this.name.split("/")[1], //姓名
        empno: userId, //工号
        isInsured: this.isInsured, //是否为子女参保
        childName: this.childName, //投保子女姓名
        gender: this.gender, //性别
        idType: this.idType, //证件类型
        idNumber: this.idNumber, //证件号
        birthDate: this.birthDate, //出生日期
        isMarried: this.isMarried, //是否结婚
        isStudent: this.isStudent, //投保子女是否在校生
        schoolCity: this.schoolCity, // 学校城市
        schoolName: this.schoolName, // 学校
        cityCode: this.cityCode
      };
      if (id) {
        json.id = id;
      }
      apis.addOrUpdateEmployeeChild(json).then(res => {
        if (res.code == "200") {
          console.log("res11", res.data);
          if (res.code == 200) {
            this.confirmLoading = false;
            this.$router.replace('/insuranceHome');
          }
        }
        this.confirmLoading = false;
        this.showChange = false;
      }).catch(() => {
        this.showChange = false;
        this.confirmLoading = false;
      });
    },
    // 显示投保子女姓名
    isShowChildrenNamet() {
      this.childList = this.childList.filter((item) => item.childName && item.idNumber);
      if (this.childList.length > 0) {
        this.showChildrenNamet = true;
      } else {
        this.showChildrenNamet = false;
      }
      // this.editId = '';
      // this.gender = '';
      // this.idType = '身份证';
      // this.childName = '';
      // this.idNumber = '';
      // this.birthDate = '';
      // this.BirthdateTime = new Date();
      // this.isMarried = '';
      // this.isStudent = '';
      // this.schoolCity = '';
      // this.schoolName = '';
      // this.cityCode = '';
    },

    blurchildName() {
      this.showChildrenNamet = false;
    },
    // changeChildrenNamet() {
    //   this.querByChildInfo(this.childName);
    // },
    //投保子女姓名确定
    confirmChildrenNamet(value) {
      this.childName = value ? value.text : this.childName;
      this.childInfoIdNumber = value;
      this.showChildrenNamet = false;
      this.querByChildInfo(value.value);
    },
    //投保子女姓名确定
    querByChildInfo(value) {
      const userId = this.name.split("/")[0];
      const json = {
        empno: userId,
        page: 1,
        pageSize: 1000,
        keywords: value,
        filterPolicyStatus: "失效"
      };
      apis.queryEmployeeChild(json).then(res => {
        if (res.code == "200") {
          // this.childList = res.data;
          this.editId = res.data.length > 0 ? res.data[0].id : '';
          this.gender = res.data.length > 0 ? res.data[0].gender : '', //性别
            this.idType = res.data.length > 0 ? res.data[0].idType : '身份证', //证件类型
            this.idNumber = res.data.length > 0 ? res.data[0].idNumber : '', //证件号
            this.birthDate = res.data.length > 0 && res.data[0].birthDate ? moment(res.data[0].birthDate).format(
              "YYYY-MM-DD"
            ) : null, //出生日期
            this.BirthdateTime = res.data.length > 0 && res.data[0].birthDate ? new Date(res.data[0].birthDate) : new Date(),
            this.isMarried = res.data.length > 0 ? res.data[0].isMarried : '', //是否结婚
            this.isStudent = res.data.length > 0 ? res.data[0].isStudent : '', //投保子女是否在校生
            this.schoolCity = res.data.length > 0 ? res.data[0].schoolCity : '', // 学校城市
            this.schoolName = res.data.length > 0 ? res.data[0].schoolName : '', // 学校
            this.cityCode = res.data.length > 0 && res.data[0].cityCode ? res.data[0].cityCode.toString() : '';
          if (this.idNumber && !this.birthDate) {
            let birthday = "";
            let time = '';
            birthday = this.idNumber.substr(6, 8);
            time = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
            this.birthDate = time;
            this.BirthdateTime = new Date(time);
          }
          if (this.birthDate) {
            this.isExceedSixteen();
            // let currentDate = new Date();
            // let currentYear = currentDate.getFullYear();
            // let selectedYear = new Date(this.birthDate).getFullYear();
            // if (currentYear >= selectedYear + 17) {
            //   console.log("当前日期大于等于16年");
            //   this.isGrowUp = true;
            // } else {
            //   this.isGrowUp = false;
            //   console.log("当前日期小于16年");
            // }
          }
        }
      });
    },
    // 投保子女姓名取消
    cancelChildrenNamet() {
      this.showChildrenNamet = false;
    },
    // 显示证件类型
    isShowCardType() {
      this.showCardType = true;
    },
    //显示证件确定
    confirmShowCardType(value) {
      console.log("value", value);
      this.idType = value;
      this.showCardType = false;
    },
    // 显示证件取消
    cancelShowCardType() {
      this.showCardType = false;
    },
    // 出生日期
    showBirthdate() {
      this.isShowBirthdate = true;
    },
    //出生日期确定
    comfirmBirthdate(value) {
      console.log("value", value);
      this.birthDate = moment(value).format("YYYY-MM-DD");
      this.isShowBirthdate = false;
      // let currentDate = new Date();
      // let currentYear = currentDate.getFullYear();
      // let selectedYear = value.getFullYear();
      // if (currentYear >= selectedYear + 17) {
      //   console.log("当前日期大于等于16年");
      //   this.isGrowUp = true;
      // } else {
      //   this.isGrowUp = false;
      //   console.log("当前日期小于16年");
      // }
      this.isExceedSixteen();
      this.isMarried = '';
      this.isStudent = '';
      this.$refs.form.resetValidation('isMarried');
      this.$refs.form.resetValidation('isStudent');
    },
    // 学校城市
    showSchoolCity() {
      this.isSchoolCity = true;
    },
    //学校城市确定
    confirmSchoolCity(value) {
      console.log("value", value);
      this.cityCode = value[value.length - 1].code;
      this.schoolCity = value.map(item => item.name).join("/");
      this.isSchoolCity = false;
    },
    //跳转
    cancelBack() {
      this.$router.replace('/insuranceHome');
    },
    //选择变更子女
    confirmShowChangeChildren(value) {
      this.isShowChangeChildren = false;
      this.changeLoading = true;
      const json = {
        employeeName: this.name.split("/")[1], //姓名
        empno: this.name.split("/")[0], //工号
        // id: this.editId,
        isInsured: this.isInsured, //是否为子女参保
        childName: this.childName, //投保子女姓名
        gender: this.gender, //性别
        idType: this.idType, //证件类型
        idNumber: this.idNumber, //证件号
        birthDate: this.birthDate, //出生日期
        isMarried: this.isMarried, //是否结婚
        isStudent: this.isStudent, //投保子女是否在校生
        schoolCity: this.schoolCity, // 学校城市
        schoolName: this.schoolName, // 学校
        cityCode: this.cityCode
      };
      const valueFilter = this.childList.filter(item => item.idNumber == value.value);
      if (valueFilter.length > 0) {
        json.changeId = valueFilter[0].id;
      }
      apis.addOrUpdateEmployeeChild(json).then(res => {
        if (res.code == "200") {
          if (res.code == 200) {
            this.changeLoading = false;
            this.$router.replace('/insuranceHome');
          }
        }
        this.showChange = false;
        this.changeLoading = false;
      }).catch(() => {
        this.changeLoading = false;
        this.showChange = false;
      });
    },
    //显示变更子女
    confirmChange() {
      this.isShowChangeChildren = true;
      console.log("变更");
    },
    //新增
    addChange() {
      console.log("新增");
      if (this.isStudent == "") {
        this.isValidate = true;
      }
      if (this.isStudent == 1) {
        this.isGrowUp = true;
      }
      this.addOrUpdateEmployeeChilds(null);

    },
    //确认申报
    handleConfirm() {
      if (this.isStudent == 0) {
        this.schoolCity = '';
        this.schoolName = '';
      }
      if (this.name) {
        this.nameIsRequired = false;
      } else {
        this.nameIsRequired = true;
      }
      this.$refs.form.validate().then(() => {
        let changeId = null;
        const repetitionIdCard = this.childList.filter(item => item.idNumber == this.idNumber);
        if (this.isInsured == 0) {
          this.addOrUpdateEmployeeChilds(null);
        } else {
          if (this.childList.length < 1) {
            this.addOrUpdateEmployeeChilds(null);
          } else if (this.childList.length > 0 && repetitionIdCard.length > 0) {
            changeId = repetitionIdCard[0].id;
            this.addOrUpdateEmployeeChilds(changeId);
          } else {
            this.showChange = true;
          }
        }

      }).catch((error) => {
        // 校验失败，捕获错误信息
        console.log("Validation error:", error);
        error.forEach(item => {
          this.$refs.form.scrollToField(item.name);
          return;
        });
      });

    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .declareContainer {
    width: 100%;
  }

  // .footerBtn {
  //   width: 100%;
  // }
}

@media screen and (min-width: 600px) {
  .declareContainer {
    width: 276px * $zoom;
  }

  // .footerBtn {
  //   width: 276px * $zoom;
  // }
}

.declareContainer {
  padding: 20px 20px 0 20px;
  background-color: #fff;

  .headerCon {
    display: flex;
    align-content: center;
    justify-content: space-between;
    border-bottom: 1px solid #ececec;
    padding-bottom: 15px;

    .left {
      .van-icon {
        font-size: 36px;
      }
    }

    .headerTit {
      font-family: PingFang-SC, PingFang-SC;
      font-weight: 600;
      font-size: 37px;
      color: #282b32;
    }

    .right {
      img {
        width: 36px;
        height: 36px;
      }
    }
  }


  ::v-deep {
    .popupCon {
      background-color: initial;
      // opacity: 0;
    }

    .el-select {
      width: 100%;
    }

    .el-input__inner {
      padding-left: 0px !important;
      border: 0;
      background-color: #f7f9fa;
    }
  }

  .changeIcon {
    position: absolute;
    right: 30px;
    top: 30px;
  }

  .contenCon {
    height: calc(100vh - 205px);
    overflow-y: auto;

    &::-webkit-scrollbar {
      display: none;
    }

    .fieldImg {
      width: 30px;
      height: 26px;
    }
  }

  .radioCon1 {
    margin-bottom: 0 !important;
  }

  .radioCon {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 29px;
    color: #333333;
    // line-height: 22px;
    margin-bottom: 25px;

    .title {
      margin-bottom: 15px;
      line-height: 40px;
    }
  }

  ::v-deep {

    // .van-radio__label {}
    .van-radio__icon {
      font-size: 29px;
    }

    .van-radio {
      margin-right: 150px;
    }
  }

  ::v-deep .van-cell__title {
    font-size: 29px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    margin-bottom: 15px;
  }

  ::v-deep(.van-cell-group) {
    .van-cell {
      display: flex;
      flex-direction: column;
      padding: 18px 0;
    }

    .van-field__value {
      background-color: #f7f9fa;
      padding: 10px 20px;
    }

    .van-cell::after {
      content: "";
      border-bottom: 0;
    }

    .van-field__label {
      font-size: 29px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #282b32;
    }

    .van-field__label {
      width: 500px !important;
    }

    .endPlace .van-field__label::after {
      content: "（默认为公司，有需要可修改）";
      font-size: 16px;
      color: #b5b9bb;
    }
  }

  ::v-deep .van-hairline--top-bottom::after {
    content: "";
    border: 0;
  }

  .footerBtn {
    background-color: #fff;
    padding: 15px 0;
    width: 100%;
    display: flex;
    justify-content: space-around;

    ::v-deep(.van-button--small) {
      height: 88px;
      border-radius: 10px;
      font-size: 27px;
      border: 0;
    }
  }
}
</style>
